module.exports = __webpack_public_path__ + "static/media/emami_logo.3ea634d7.jpeg";